import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	recentlyViewedProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentlyViewedProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recentlyViewedProjects: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects',
		defaultMessage: 'Recently Viewed Projects',
		description: 'Section title for recently viewed projects',
	},
	recentlyViewedProjectsGalaxia: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects-galaxia',
		defaultMessage: 'Recently viewed spaces',
		description: 'Section title for recently viewed projects',
	},
});
